export default "__VITE_ASSET__oWlUZtBc__"